import {LocalizationProvider, DesktopDatePicker, MobileDatePicker} from '@mui/x-date-pickers';
import {AdapterDayjs} from '@mui/x-date-pickers/AdapterDayjs';

export default function DatePickerWrapper({label, selectedDate, onChange, disabled, isDesktop, usePdfLayout, sx}) {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      {
        isDesktop ?
          <DesktopDatePicker
            label={label}
            format={usePdfLayout ? '' : 'MM/DD/YYYY'}
            value={selectedDate}
            disabled={disabled}
            onChange={onChange}
            sx={...sx}
          /> :
          <MobileDatePicker
            label={label}
            format='MM/DD/YYYY'
            value={selectedDate}
            disabled={disabled}
            onChange={onChange}
            sx={...sx}
          />
      }
    </LocalizationProvider>
  );
}
